import React from 'react';
import styles from './Tuto.module.css';

const Tuto = () => {
    return (
        <div className={ styles.container }>
            Tuto
        </div>
    )
}

export default Tuto;